const SELECTOR_LESSON_COLLAPSE = '.js-lessons-collapse';
const SELECTOR_COLLAPSE_BTN = '.js-lesson-collapse-btn';
const SELECTOR_INDIVIDUAL_LESSON_COLLAPSE = '.js-lesson-individual-collapse';

export default function setupPresalesLessonsListCollapse() {
  $(document).on('turbolinks:load', () => {
    lessonsListCollapseInit();
  });
  lessonsListCollapseInit();

  function lessonsListCollapseInit() {
    if ($(SELECTOR_LESSON_COLLAPSE).length) {
      const $btn = $(SELECTOR_COLLAPSE_BTN);
      const $lessonCollapse = $(SELECTOR_LESSON_COLLAPSE);

      $lessonCollapse.on('shown.bs.collapse', e => {
        e.currentTarget.parentElement.setAttribute("aria-expanded", "true");
        // List contains other collapse elements which bubble
        if (e.currentTarget === e.target) {
          $btn.text('Show less');

          // Focus first collapse button of the new group
          $lessonCollapse.find('li:first-child button').trigger('focus');
        }
      });

      $lessonCollapse.on('hidden.bs.collapse', e => {
        e.currentTarget.parentElement.setAttribute("aria-expanded", "false");
        // List contains other collapse elements which bubble
        if (e.currentTarget === e.target) {
          $btn.text($btn.attr('data-btn-expand-text'));
        }
      });
    }

    // Bootstrap collapse has a bug where it doesn't apply the
    // correct state where an element is rendered already expanded,
    // so forcing it here
    $(SELECTOR_INDIVIDUAL_LESSON_COLLAPSE).each((ind, el) => {
      $(el).on('hidden.bs.collapse', addCollapseClass);
      $(el).on('shown.bs.collapse', removeCollapseClass);

      function addCollapseClass() {
        $(el)
          .prev()
          .addClass('collapsed');
      }

      function removeCollapseClass() {
        $(el)
          .prev()
          .removeClass('collapsed');
      }
    });
  }
}
